import React, { useContext, useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import FadeLoader from 'react-spinners/FadeLoader';
import { storeInLocalStorage } from "../../Utils/LocalStorage";
import { AuthContext } from '../../context/AuthContext';

function VerificationViaEmail() {
    const {setIsAuthenticated,isAuthenticated} = useContext(AuthContext);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token");
    const [isVerifying, setIsVerifying] = useState(true);
    const [verificationMessage, setVerificationMessage] = useState("");
    const hasVerified = useRef(false);

    useEffect(() => {
        console.log("=== VerificationViaEmail useEffect ===");
        console.log("Token:", token);
        console.log("hasVerified.current:", hasVerified.current);
        console.log("Current URL:", window.location.href);
        
        if (token && !hasVerified.current) {
            console.log("✅ Starting verification process");
            hasVerified.current = true;
            verifyEmail();
        } else if (!token) {
            console.log("❌ No token found");
            setIsVerifying(false);
            setVerificationMessage("Invalid or missing token.");
        } else {
            console.log("⚠️ Verification already attempted");
        }
    }, [token]);

    const verifyEmail = async () => {
        console.log("=== verifyEmail function called ===");
        console.log("Backend URL:", process.env.REACT_APP_BACKEND_URL);
        
        const verificationPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/verify_email`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
        });

        console.log("📤 Sending verification request...");

        toast.promise(
            verificationPromise.then(async (res) => {
                console.log("📥 Got response from /verify_email");
                console.log("Response status:", res.status, res.ok);
                const data = await res.json();
                console.log("Response data:", data);
                
                if (!res.ok) {
                    console.log("❌ Verification failed:", data.message);
                    throw new Error(data.message || "Email verification failed.");
                }
                console.log("✅ Verification successful");
                return data;
            }),
            {
                loading: "Verifying email...",
                success: (data) => {
                    console.log("🎉 Toast success callback");
                    setIsVerifying(false);
                    // Navigate to EmailVerified page instead of showing message
                    setTimeout(() => {
                        navigate('/email-verified');
                    }, 500);
                    return "Email verified successfully!";
                },
                error: (err) => {
                    console.log("❌ Toast error callback:", err);
                    setVerificationMessage(err.message || "Email verification failed.");
                    setIsVerifying(false);
                    return err.message || "Email verification failed.";
                }
            }
        ).then(async (data) => {
            // This block will only run if verification was successful
            // But we're navigating away, so we can skip the payment check here
            // The EmailVerified page will handle navigation to beta subscription
            console.log("✅ Verification completed, navigating to EmailVerified page");
            console.log("=== Starting post-verification flow ===");
            console.log("User data:", data);
            console.log("Device:", data.device);
            console.log("Redirect URLs:", data.redirect_urls);
            
            setIsAuthenticated(true);
            console.log("✅ setIsAuthenticated(true) called");
            
            storeInLocalStorage({
                user_id: data.user_id,
                access_token: data.access_token,
                email:data.email
            });
            console.log("✅ Stored in localStorage");
            
            // Navigation is handled in the toast success callback
            // No need to check payment method here - EmailVerified page will handle navigation

        }).catch((error) => {
            console.error("=== Error in verification flow ===");
            console.error("Error:", error);
        });
    };

    return (
        <div className="flex justify-center items-center flex-col" style={{ height: "60vh" }}>
            {isVerifying && (
                <div className="fixed top-0 left-0 w-screen h-screen flex justify-center items-center z-50 bg-black bg-opacity-50">
                    <div className="h-56 w-56 md:w-96 lg:w-96 xl:w-96 2xl:w-96 md:h-72 lg:h-72 xl:h-72 2xl:h-72 rounded-lg bg-white dark:bg-[#222a32] flex justify-center items-center flex-col shadow-lg">
                        <div className="flex justify-center items-center">
                            <FadeLoader color="#2DEEAA" />
                        </div>
                        <p className="text-center mt-10 dark:text-white">Hold on, Verifying...</p>
                    </div>
                </div>
            )}

            {!isVerifying && verificationMessage && (
                <div className="text-center">
                    <p className="mt-5 text-lg font-semibold dark:text-white">{verificationMessage}</p>
                </div>
            )}
        </div>
    );
}

export default VerificationViaEmail;
